import { render, staticRenderFns } from "./CustomNumberInput.vue?vue&type=template&id=4bbc5ec2&scoped=true"
import script from "./CustomNumberInput.vue?vue&type=script&lang=js"
export * from "./CustomNumberInput.vue?vue&type=script&lang=js"
import style0 from "./CustomNumberInput.vue?vue&type=style&index=0&id=4bbc5ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc5ec2",
  null
  
)

export default component.exports